import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PATHS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import type UpdateStorefrontProductsDto from "./dto/update-storefront-products.dto";

export const StorefrontProductsEffectActions = {
  updateStorefrontProducts: `${Entities.StorefrontProducts}_updateStorefrontProducts`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.StorefrontProducts,
  initSchema,
  aliasName: DIContainerKeys.StorefrontProductsService,
})
export class StorefrontProductsService extends HttpService {
  @loader(Loaders.GetStorefrontProductsLoader)
  @action(DIContainerKeys.StorefrontProductsService)
  public *updateStorefrontProducts(dto: UpdateStorefrontProductsDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetStorefrontProductsLoader, true);
    yield call(
      this.post,
      {
        url: BASE_API_PATHS.updateStoreFrontProducts,
        domain: API_DOMENS.PSA_API,
        body: this.toFormData({
          ProductList: JSON.stringify(dto.productList),
        }),
      },
      ReducerMethods.UPDATE
    );
    yield this.setLoaderState(Loaders.GetStorefrontProductsLoader, false);
  }
}